import { gql, useQuery } from "@apollo/client";
import { BestPerformingOffersQueryQuery } from "../../../../../schemaTypes";

export const bestPerformingOffersQuery = gql`
  query BestPerformingOffersQuery {
    bestPerformingOffers {
      id
      title
      offerType
      redemptions
    }
  }
`;

export interface WithBestPerformingOffers {
  bestPerformingOffers: NonNullable<BestPerformingOffersQueryQuery["bestPerformingOffers"]>;
}

interface Props {
  children: (data: WithBestPerformingOffers) => React.ReactElement | null;
}

export const BestPerformingOffersController: React.FC<Props> = ({ children }) => {
  const { data } = useQuery<BestPerformingOffersQueryQuery>(bestPerformingOffersQuery);
  const bestPerformingOffers = data?.bestPerformingOffers ?? [];
  
  return children({ bestPerformingOffers });
};
